import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface StepperStep {
  label: string;
  number?: number;
  icon?: string;
  isLocked?: boolean;
  isClickable?: boolean;
}

@Component({
  selector: 'app-acv-stepper',
  templateUrl: './acv-stepper.component.html',
  styleUrls: ['./acv-stepper.component.scss']
})
export class AcvStepperComponent {
  @Input() steps: StepperStep[] = [];
  @Input() activeIndex: number = 0;
  @Input() showProgress: boolean = true;
  @Input() progressText: string = 'In Progress';
  @Input() progressValue: number = 0;
  @Input() maxWidth: string = '700px';

  @Output() stepClick = new EventEmitter<number>();

  onStepClick(index: number, step: StepperStep) {
    if (step.isClickable && !step.isLocked && index <= this.activeIndex) {
      this.stepClick.emit(index);
    }
  }

  getProgressPercentage(): number {
    if (this.steps.length === 0) return 0;
    return Math.round(((this.activeIndex + 1) / this.steps.length) * 100);
  }

  isStepActive(index: number): boolean {
    return index === this.activeIndex;
  }

  isStepCompleted(index: number): boolean {
    return index < this.activeIndex;
  }

  isStepLocked(index: number): boolean {
    // Only lock steps that are explicitly marked as locked or are beyond the active index
    // Don't automatically lock the last step
    const step = this.steps[index];
    return step?.isLocked === true || index > this.activeIndex;
  }

  shouldShowLockIcon(index: number): boolean {
    const step = this.steps[index];
    // Only show lock icon if step is explicitly marked as locked
    return step?.isLocked === true;
  }
}
